import { useLocation } from '@grandvisionhq/frk-routing';

const useProductDetailQueryParams = ()=>{
    const { query  } = useLocation();
    const isInsuranceReimbursable = query.get('isInsuranceReimbursable');
    const offerings = query.get('offerings');
    return {
        isReimbursable: isInsuranceReimbursable === 'true',
        filteredOfferings: offerings ? offerings.split(',').filter(Boolean) : []
    };
};

export { useProductDetailQueryParams };
//# sourceMappingURL=use-product-detail-query-params.js.map
